//Please add the language resource
const deliveryWarehouse = {
  warehouseNo:'warehouseNo',
  warehouseName:'warehouseName',
  createTime:"createTime",
  creator:"creator",
  updateTime:"updateTime",
  updater:"updater",
  msg:{
  }
};
export default deliveryWarehouse



// WEBPACK FOOTER //
// ./src/page/md/deliveryWarehouse/lang/deliveryWarehouse.en.js